
import { createSelector } from '@ngrx/store'
import { LOAD_ALL_EVENTS_FLAG,  } from '../../../../globals/store/events.data'
import { eventListReselector } from "./events.reselector"
import { WFWorker, WorkerWithProfile, WorkforceGroup } from '../../../../globals/store/workforce.data';
import { JoiEvent } from 'globals/store/events.data';
import { Account, isAccountManager } from "../../../../globals/store/accounts.data";
import { Dictionary } from "@ngrx/entity";
import { userStateSelector } from '../user.era';
import { permissionsStateSelector } from '../permissions.era';
import { accountStateSelector } from '../accounts.era';
import { eventStateSelector } from '../events.era';
import { workforceStateSelector } from '../workforce.era';
import { contactsStateSelector } from '../contacts.era';
import { eventPreferencesStateSelector } from '../event.preferences.era';



const user = createSelector(userStateSelector, (state) => state.user);
const eventPreferencesLoading = createSelector(eventPreferencesStateSelector, (state) => state.loading)
const contactEntities = createSelector(contactsStateSelector, (state) => state.entities)
const eventId = createSelector(eventStateSelector, (state) => state.eventId)
const event = createSelector(eventStateSelector, (state) => state.event)
const workers = createSelector(workforceStateSelector, (state) => state.workforce)  
const wf_groups = createSelector(workforceStateSelector, (state) => state.wf_groups)
const workersByEmail = createSelector(workforceStateSelector, (state) => state.workersByEmail)
const account = createSelector(accountStateSelector, (state) => state.account)
const accountEntities = createSelector(accountStateSelector, (state) => state.entities)
const eventWidePermissions = createSelector(permissionsStateSelector, (state) => state.eventWidePermissions)

export const programWorkforceReselector = createSelector(
  workers,
  eventWidePermissions,
  (workforce: WFWorker[], eventWidePermissions) => workforce.filter(({ uid, email }) => 
    (eventWidePermissions[uid] && eventWidePermissions[uid].includes('program')) ||
    (eventWidePermissions[email] && eventWidePermissions[email].includes('program'))
  )
)

export const unaddedContactsReselector = createSelector(
  contactEntities,
  workersByEmail,
  (contacts, workersByEmail) => {
    if (!workersByEmail) return Object.values(contacts)
    return Object.values(contacts).filter((c: WorkerWithProfile) => !workersByEmail[c.email])
  }
)

export const potentialEventOwnersReselector = createSelector( // potential owner must be on the account and the event before being able to be invited.  They also must have a user id, as changing the event owner means changing a uid.
  account,
  event,
  workers,
  (account, event, workers ) => !account || !event ||!account.users || !workers ? [] : workers.filter(w => w.uid !== event.owner_uid && isAccountManager(account, w.uid))
)


export const potentialEventOwnersByEventIdsReselector = createSelector( // potential owner must be on the account and the event before being able to be invited.  They also must have a user id, as changing the event owner means changing a uid.
  accountEntities,
  eventListReselector,
  (accounts: Dictionary<Account>, events: JoiEvent[]) => {
    const potentials: Dictionary<WFWorker[]> = {}
    events.forEach(event => {
      const account = accounts[event.accountId]
      potentials[event.eventId] = event.workforce.filter(w => w.uid !== event.owner_uid && isAccountManager(account, w.uid))
    })
    return potentials
  }
)




export const getUserWorkforceGroups = (wf_groups: WorkforceGroup[], userEmail: string): Set<string> => 
  new Set(wf_groups.filter(wfGroup => wfGroup.members.includes(userEmail)).map(wfGroup => wfGroup.name))

export const myGroupsReselector = createSelector(
  user,
  eventPreferencesLoading,
  wf_groups,
  eventId,
  (user, eventPreferencesLoading, wf_groups, eventId) => 
    !user || eventPreferencesLoading || !wf_groups || !eventId || eventId === LOAD_ALL_EVENTS_FLAG ? null : getUserWorkforceGroups(wf_groups, user.email)
)